Object.defineProperty(exports, '__esModule', {
  value: true
});
var dateFns = require('date-fns');
var helpers_date_startOfWeekUK = require('./startOfWeekUK.js');
var INVOICE_RUN_DAY = 3; // Thursday, 0 = Monday
var INVOICE_RUN_HOUR = 3; // 3AM, 0 = Midnight
/**
 *
 * @returns The last invoice date that has ran (last Thursday thats passed) and next invoice date (the next Thursday to come)
 */
var getNextAndLastInvoiceRun = function getNextAndLastInvoiceRun(runDay) {
  if (runDay === void 0) {
    runDay = new Date();
  }
  // Monday of this week
  var startOfWeek = helpers_date_startOfWeekUK.startOfWeekUK(dateFns.startOfDay(runDay));
  // Thursday of this week
  var thursdayOfThisWeek = dateFns.addDays(startOfWeek, INVOICE_RUN_DAY);
  // Thursday of this week at 3am
  var thisWeekInvoiceStartTime = dateFns.addHours(thursdayOfThisWeek, INVOICE_RUN_HOUR);
  // Thursday of next week at 3am
  var nextWeeksInvoiceStartTime = dateFns.addWeeks(thisWeekInvoiceStartTime, 1);
  // If this Thursday at 3am is in the past, next invoice is next weeks Thursday
  // Otherwise, we're at the beginning of the week and next invoice is this Thursday.
  var nextInvoiceRun = thisWeekInvoiceStartTime.getTime() < runDay.getTime() ? nextWeeksInvoiceStartTime : thisWeekInvoiceStartTime;
  return {
    nextInvoiceRun: nextInvoiceRun,
    lastInvoiceRun: dateFns.subWeeks(nextInvoiceRun, 1)
  };
};
exports.INVOICE_RUN_DAY = INVOICE_RUN_DAY;
exports.INVOICE_RUN_HOUR = INVOICE_RUN_HOUR;
exports.getNextAndLastInvoiceRun = getNextAndLastInvoiceRun;